module.exports = {
    maps: process.env.EXAMPLES_API_KEY,
    routing: process.env.EXAMPLES_API_KEY,
    search: process.env.EXAMPLES_API_KEY,
    trafficFlow: process.env.EXAMPLES_API_KEY,
    trafficIncidents: process.env.EXAMPLES_API_KEY,
    extendedSearch: process.env.EXAMPLES_API_KEY,
    extendedRouting: process.env.EXAMPLES_API_KEY
};
